import './UIWallTypeList3d.css'
import React from 'react';
import {WallType} from '../internalModules';
import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { globalRenderer } from '../Graphics'

type Props = {
  assemblies: WallType[]
}

export default function UIWallTypeList3d({assemblies}: Props) {

  const mountRef = React.useRef<HTMLDivElement>(null)
  const needRenderRef = React.useRef<boolean>(true)

  



  React.useEffect(() => {
    // function to render a scene at a location
    const renderScene = ( scene: THREE.Scene, camera: THREE.PerspectiveCamera, divId: string) => {

      // get the target div element
      const elem = document.getElementById(divId)
      if (!elem) {
        return
      }

      // get the wall type
      const assembly = assemblies.filter( x => x.guid === divId)[0]

      if (assembly.orbitControls === undefined) {
        assembly.orbitControls = new OrbitControls(camera, elem!)
        assembly.orbitControls.addEventListener('change', renderScenes)
        assembly.orbitControls.update()
      }

      // get the viewport relative position of this element
      const domRect = elem?.getBoundingClientRect() as DOMRect
      const pixelRatio = window.devicePixelRatio
      const left = domRect.left * pixelRatio
      const right = domRect.right * pixelRatio
      const top = domRect.top * pixelRatio
      const bottom = domRect.bottom * pixelRatio
      const width = domRect.width * pixelRatio
      const height = domRect.height * pixelRatio
      const isOffscreen =
        bottom < 0 ||
        top > window.innerHeight ||
        right < 0 ||
        left > window.innerWidth
  
      if (isOffscreen) {
        return
      }

      const transform = `translateY(${window.scrollY}px)`
      globalRenderer.domElement.style.transform = transform

      camera.aspect = width / height
      camera.updateProjectionMatrix()
      const positiveYUpBottom = (window.innerHeight * pixelRatio) - top - height
      globalRenderer.setScissor(left, positiveYUpBottom, width, height)
      globalRenderer.setViewport(left, positiveYUpBottom, width, height)
      globalRenderer.render(scene, camera)
    }
    
    const renderScenes = function () {
      resizeRendererToDisplaySize()
  
      globalRenderer.setScissorTest(false)
      globalRenderer.clear(true, true)
      globalRenderer.setScissorTest(true)
  
      for (const assembly of assemblies) {
        renderScene(assembly.scene, assembly.camera, assembly.guid)
      }
      //check if we need a first render
      if(needRenderRef.current) {
        needRenderRef.current = false
        requestAnimationFrame( renderScenes )
      }
    }
  
    const resizeRendererToDisplaySize = () => {
      const canvas = globalRenderer.domElement;
      const pixelRatio = window.devicePixelRatio;
      const width  = canvas.clientWidth  * pixelRatio | 0;
      const height = canvas.clientHeight * pixelRatio | 0;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        globalRenderer.setSize(width, height, false);
      }
      return needResize;
    }
  
    const onWindowResize = function () {
      globalRenderer.setSize( window.innerWidth, window.innerHeight );
      renderScenes()
    }

    globalRenderer.setSize( window.innerWidth, window.innerHeight )
    mountRef.current?.appendChild( globalRenderer.domElement )
    window.addEventListener("resize", onWindowResize, false);
    window.addEventListener("scroll", renderScenes, false)
    
    renderScenes()

    // cleanup function when component is removed
    //return () => {mountRef.current?.removeChild( globalRenderer.domElement)}
  }, [assemblies]);

  return (
    <div ref={mountRef} id={'c'}>

    </div>
  );
}


